import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-imprime-ticket',
  templateUrl: './imprime-ticket.component.html',
  styleUrls: ['./imprime-ticket.component.css']
})
export class ImprimeTicketComponent implements OnInit {
  errMsg:any;
  okMsg:any;
  loading:boolean=false;
  qrcode:string=""
  formato:any=[];
  formStyle:any[];
  elemImp:any[];
  elemStyle:any[]=[]  
  consolidaImp:boolean = false;
  folioIni:number = -1;
  folioFin:number = -1;
  agruparTickets:boolean=false;

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<ImprimeTicketComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    //console.log(this.data);
    if(this.data){
      this.agruparTickets = this.data.grupo;
      if(this.agruparTickets){
        console.log(this.data.item);
        setTimeout(() => {
          var auxChk = <HTMLInputElement>document.getElementById("chkConsolida");
          if(auxChk){
            auxChk.checked = true;
            auxChk.style.visibility = "hidden";
            this.fnConsolidaImpresion(auxChk);
          }            
        }, 150);
      }
      //else{
        this.qrcode = "F" + this.data.item.folio + "|" + this.data.item.fecha_emi + "|" + this.data.item.hora_emi;
      //}
    }
    this.dataService.getFormatoImp(1, 1).subscribe(
                      rows => {   
                              this.formato = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFormatoImpCargado());
  }

  fnFormatoImpCargado(){
    //console.log("Formatos: ");
    //console.log(this.formato);
    var arrIdForms = [];
    for(var i = 0; i < this.formato.length; i++){
      arrIdForms.push(this.formato[i].id);
    }
    //--> Obtener styles
    this.dataService.getFormStyles(arrIdForms.join(","), "1,2").subscribe(
                rows => {   
                        this.formStyle = <any>rows
                        },          
                error => this.errMsg = <any>error,
                () => this.fnFormStyleCargado())
  }

  fnFormStyleCargado(){
    //console.log(this.formStyle)
    var arrStyles=[];
    for(var i = 0; i < this.formStyle.length; i++){
      arrStyles.push(this.formStyle[i].style);
    }
    arrStyles = arrStyles.filter(this.dataService.onlyUnique);        
    for(var i = 0; i < arrStyles.length; i++){
      this.elemStyle[arrStyles[i]] = {};
      for(var k = 0; k < this.formStyle.length; k++){
        if(arrStyles[i] == this.formStyle[k].style){
            var auxObj = Object.keys(this.elemStyle[arrStyles[i]]);
            //console.log("Keys of Object:");
            //console.log(auxObj);
            if(auxObj.length == 0)
              this.elemStyle[arrStyles[i]] = {[this.formStyle[k].key]:this.formStyle[k].valor} ;
            else
              this.elemStyle[arrStyles[i]][this.formStyle[k].key]   = this.formStyle[k].valor;
        }
      }
    }
    //console.log(this.elemStyle);
  }

  fnImprimir(){
    var idFormato = 3;  //-->>> Formato 1 = Ticket impresora matriz, 2 = Ticket impresora térmica, 3 = Ticket térmico (Comprobante Simplificado)
    this.dataService.insLog(41,'REIMPRIMIR', "TICKETv" + idFormato, this.consolidaImp ? this.folioIni + " al " + this.folioFin : this.data.item.folio).subscribe(
                            row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.getElemFormatoImp(idFormato, "'CONTENT', 'COLUMN', 'CELL', 'NEW_LINE', 'NEW_ROW', 'STYLE', 'POSITION', 'LINE', 'RECT', 'ELLIPSE', 'END DRAW', 'IMAGE', 'GRAF1', 'GRAF2', 'GRAF3', 'GRAF4'", "1,2").subscribe(
                            rows => {   
                                    this.elemImp = <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnElementosImpresionCargados(idFormato));              
  }

  fnConsolidaImpresion(item){
    setTimeout(() => {
      if(item.checked){
        this.consolidaImp=true;
        this.folioIni = this.data.item.folio - this.data.item.i + 1;
        this.folioFin = this.folioIni + this.data.item.n - 1;
        this.qrcode = "G" + this.folioIni + ">" + this.folioFin  + "|" + this.data.item.fecha_emi + "|" + this.data.item.hora_emi;
      }
      else{
        this.consolidaImp=false;
        this.qrcode = "F" + this.data.item.folio + "|" + this.data.item.fecha_emi + "|" + this.data.item.hora_emi;

      }
    }, 50); 
  }

  fnElementosImpresionCargados(idFormato){
    var index = this.formato.findIndex(x => x.id === idFormato);
    var margins =this.formato[index].pageMargins.split(",");
    var height = 1.0;
    height = this.formato[index].lineHeight;
    var text = [];
    var text2 = [];
    var canvas = [];
    var images = [];  
    
    var auxLogo = <HTMLImageElement>document.getElementById("imgRepLogo");
    auxLogo.src = "../../../assets/logoBlack.png";
    var auxQR = <HTMLImageElement>document.getElementById("imgQR"); 
    var auxImgQR = auxQR.getElementsByTagName("img")[0];
    console.log(">>> CONSOLIDAIMP: " + this.consolidaImp);
    console.log(this.data);
    console.log(this.qrcode);
    var arrSpecialStrings = [{
      'FOLIO': this.consolidaImp ? this.folioIni + '\nal ' + this.folioFin  : this.data.item.folio,
      'TITULO': this.dataService.sDe,
      'RFC': this.dataService.sRFC,
      'DIR1': this.dataService.sDi,
      'FECHAEMI': this.data.item.fecha_emi + " " + this.data.item.hora_emi,
      'PROD': this.data.item.prod, 
      'QTY': this.consolidaImp ? this.data.item.n : this.data.item.qty,
      'TOTAL': this.consolidaImp  ?  (this.agruparTickets ? this.data.item.tot : (this.data.item.n * this.data.item.tot)) + '    (' + this.data.item.n + ')' : this.data.item.tot,
      'NUMASI_LETRA': this.dataService.fnLeeMonto(this.consolidaImp  ?  (this.agruparTickets ? this.data.item.tot : (this.data.item.n * this.data.item.tot)) : this.data.item.tot),
      'DESCUENTO': this.data.item.aplicaDescuento == undefined ? '' : this.data.item.aplicaDescuento
    }];
    var auxTxtMargen = [0,0,0,0];
    for(var i = 0; i < this.elemImp.length; i++){
      if(this.elemImp[i].tipo == "content"){
        if(this.elemImp[i].margin.indexOf(",") > 0)
          auxTxtMargen = this.elemImp[i].margin.split(",");
          auxTxtMargen = auxTxtMargen.map(function (x) {  
            return parseInt(x.toString(), 10); 
          }); 
        //console.log(auxTxtMargen);   --> NO FUNCIONAN MARGENES EN TEXTO
        text.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    margin: [0,0,0,0],
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment
                  });                  
      }
      if(this.elemImp[i].tipo == "position"){
        text2.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment,                              
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1])}
                  });                  
      }
      if(this.elemImp[i].tipo == 'image' && this.elemImp[i].dato == "ƒLOGO" ){
        images.push({
                    image:  this.dataService.fnGetBase64Image(auxLogo, auxLogo.naturalWidth, auxLogo.naturalHeight),
                    fit: [85, 30],
                    alignment: this.elemImp[i].alignment,
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1]) }
                   })
      }
      if(this.elemImp[i].tipo == 'image' && this.elemImp[i].dato != "ƒLOGO" ){
        images.push({
                    image:  auxImgQR.src,
                    fit: [110, 110],
                    alignment: this.elemImp[i].alignment,
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1]) }
                   })
      }          
      if(this.elemImp[i].tipo == 'line'){
          canvas.push({
                      type: 'line',
                      r: 0,
                      x1: parseInt(this.elemImp[i].margin.split(",")[0]),
                      y1: parseInt(this.elemImp[i].margin.split(",")[1]),
                      x2: parseInt(this.elemImp[i].margin.split(",")[2]),
                      y2: parseInt(this.elemImp[i].margin.split(",")[3]),
                      lineColor: this.elemImp[i].color,
                      lineWidth: this.elemImp[i].alignment                               
                    })
      }
      if(this.elemImp[i].tipo == 'rect'){
        canvas.push({
                    type: 'rect',
                    r: 5,
                    fillOpacity: 0.3,
                    color: this.elemImp[i].style,
                    x: parseInt(this.elemImp[i].margin.split(",")[0]),
                    y: parseInt(this.elemImp[i].margin.split(",")[1]),
                    w: parseInt(this.elemImp[i].margin.split(",")[2]),
                    h: parseInt(this.elemImp[i].margin.split(",")[3]),
                    lineColor: this.elemImp[i].color,
                    lineWidth: this.elemImp[i].alignment                               
                  })
      }
    }

    var styles = this.elemStyle;
    var stack = [];
    if (this.formato[index].tipo == "TABLA")
      stack[0] = text;
    else
      stack.push({text:text});
    stack[1] = text2;
    stack.push({canvas:canvas});
    var dd = {
      //pageSize: this.formato[index].pageSize,
      pageSize: {
        width: 212,
        height: 'auto'
      },
      pageOrientation: this.formato[index].pageOrientation,
      pageMargins: [parseInt(margins[0]), parseInt(margins[1]), parseInt(margins[2]), parseInt(margins[3])],
      content: [
        {
          lineHeight: 1.0,
          alignment: 'left',
          background: 'white',
          color: 'black',
          stack       
        }
        ,images   
      ],
      styles
    }
    //pdfMake.createPdf(dd).print();
    pdfMake.createPdf(dd).open();

  }

}
